import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

/* eslint-disable react/require-default-props */

import React, { Children, Component } from 'react';
import renamePropsWithWarning from 'react-deprecate';

import { Tooltip as StyledTooltip } from '../styled';

import Portal from './Portal';
import TooltipMarshal from './Marshal';
import Transition from './Transition';
import { getPosition } from './utils';

// global tooltip marshal
// export for testing purposes
export var marshal = new TooltipMarshal();

function getInitialState(props) {
  return {
    immediatelyHide: false,
    immediatelyShow: false,
    isVisible: false,
    isFlipped: false,
    position: props.position,
    mousePosition: props.mousePosition,
    coordinates: null
  };
}

/* eslint-disable react/sort-comp */

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || _Object$getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = getInitialState(_this.props), _this.mouseCoordinates = null, _this.handleWrapperRef = function (ref) {
      _this.wrapper = ref;
    }, _this.handleMeasureRef = function (tooltip) {
      if (!tooltip || !_this.wrapper) return;

      var _this$props = _this.props,
          position = _this$props.position,
          mousePosition = _this$props.mousePosition;
      var _this2 = _this,
          mouseCoordinates = _this2.mouseCoordinates;

      var target = _this.wrapper.children.length ? _this.wrapper.children[0] : _this.wrapper;

      var positionData = getPosition({
        position: position,
        target: target,
        tooltip: tooltip,
        mouseCoordinates: mouseCoordinates,
        mousePosition: mousePosition
      });
      _this.setState(positionData);
    }, _this.show = function (_ref2) {
      var immediate = _ref2.immediate;

      _this.setState({
        immediatelyShow: immediate,
        isVisible: true,
        coordinates: null
      });
    }, _this.hide = function (_ref3) {
      var immediate = _ref3.immediate;

      // Update state twice to allow for the updated `immediate` prop to pass through
      // to the Transition component before the tooltip is removed
      _this.setState({ immediatelyHide: immediate }, function () {
        _this.setState({ isVisible: false, coordinates: null });
      });
    }, _this.handleMouseOver = function (event) {
      var onMouseOver = _this.props.onMouseOver;
      // bail if over the wrapper, we only want to target the first child.

      if (event.target === _this.wrapper) return;

      marshal.show(_this);

      if (onMouseOver) onMouseOver(event);
    }, _this.handleMouseOut = function (event) {
      var onMouseOut = _this.props.onMouseOut;

      // bail if over the wrapper, we only want to target the first child.

      if (event.target === _this.wrapper) return;

      marshal.hide(_this);

      if (onMouseOut) onMouseOut(event);
    }, _this.handleMouseMove = function (event) {
      _this.mouseCoordinates = {
        left: event.clientX,
        top: event.clientY
      };
    }, _this.handleClick = function () {
      var hideTooltipOnClick = _this.props.hideTooltipOnClick;


      if (hideTooltipOnClick) _this.hide({ immediate: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tooltip, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var position = nextProps.position,
          truncate = nextProps.truncate,
          mousePosition = nextProps.mousePosition;

      // handle case where position is changed while visible

      if (position !== this.props.position || mousePosition !== this.props.mousePosition) {
        this.setState({ position: position, mousePosition: mousePosition, coordinates: null });
      }

      // handle case where truncate is changed while visible
      if (truncate !== this.props.truncate) {
        this.setState({ coordinates: null });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      marshal.unmount(this);
    }
  }, {
    key: 'renderTooltip',
    value: function renderTooltip() {
      var _props = this.props,
          content = _props.content,
          truncate = _props.truncate,
          component = _props.component;
      var _state = this.state,
          immediatelyHide = _state.immediatelyHide,
          immediatelyShow = _state.immediatelyShow,
          isVisible = _state.isVisible,
          mousePosition = _state.mousePosition,
          position = _state.position,
          coordinates = _state.coordinates;

      // bail immediately when not visible, or when there is no content

      if (!isVisible || !content) return null;

      // render node for measuring in alternate tree via portal
      if (!coordinates) {
        var MeasurableTooltip = component;
        return React.createElement(
          Portal,
          null,
          React.createElement(
            MeasurableTooltip,
            {
              innerRef: this.handleMeasureRef,
              style: { visibility: 'hidden' }
            },
            content
          )
        );
      }

      // render and animate tooltip when coordinates available
      var transitionProps = {
        component: component,
        immediatelyHide: immediatelyHide,
        immediatelyShow: immediatelyShow,
        mousePosition: mousePosition,
        position: position,
        coordinates: coordinates,
        truncate: truncate
      };

      return React.createElement(
        Transition,
        transitionProps,
        content
      );
    }
    // eslint-disable-next-line react/no-unused-prop-types


    // Update mouse coordinates, used when position is 'mouse'.
    // We are not debouncing/throttling this function because we aren't causing any
    // re-renders or performaing any intensive calculations, we're just updating a value.
    // React also doesn't play nice debounced DOM event handlers because they pool their
    // SyntheticEvent objects. Need to use event.persist as a workaround - https://stackoverflow.com/a/24679479/893630

  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          Tag = _props2.tag;


      return React.createElement(
        Tag,
        {
          onClick: this.handleClick,
          onMouseMove: this.handleMouseMove,
          onMouseOver: this.handleMouseOver,
          onMouseOut: this.handleMouseOut,
          ref: this.handleWrapperRef
        },
        Children.only(children),
        this.renderTooltip()
      );
    }
  }]);

  return Tooltip;
}(Component);

Tooltip.defaultProps = {
  component: StyledTooltip,
  delay: 300,
  mousePosition: 'bottom',
  position: 'bottom',
  tag: 'div'
};


export { Tooltip as TooltipBase };

export default renamePropsWithWarning(Tooltip, {
  description: 'content'
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/tooltip/dist/esm/components/Tooltip.js
// module id = 329
// module chunks = 0